/** Sparse atmospheric lines — short, non-verbatim mood text. */
export const QUOTES = [
  '三颗太阳，一种命运。',
  '恒纪元只是喘息，不是承诺。',
  '在混沌里建起的文明，终将学会沉默。',
  '天空不是屋顶，是审判。',
  '他们把希望写在不会融化的石头上。',
  '光来了，影子就无处可逃。',
  '当第二颗太阳升起，日历便失去意义。',
  '寒冷比火焰更有耐心。',
  '观测者以为自己在看，其实也被时间看着。',
  '每一次重生，都比上一次更短。',
  '地平线那边，仍是同样的三团火。',
  '秩序是短暂的幻觉，混乱才是母语。',
  '文明编号在增加，宇宙不在意。',
  '他们学会在阴影里播种。',
  '如果太阳会说谎，恒纪元就是它的修辞。',
  '逃离，还是仰望——这是同一场考试。',
  '废墟记得每一轮炎热。',
  '星轨是写给后来者的警告。',
  '在三体世界，明天是概率。',
  '我们站在地表，却像站在命运的刀刃上。',
];

export function createQuoteRotator(intervalSec = 60) {
  let index = Math.floor(Math.random() * QUOTES.length);
  let elapsed = 0;
  let current = QUOTES[index];

  return {
    get text() {
      return current;
    },
    update(dt) {
      elapsed += dt;
      if (elapsed >= intervalSec) {
        elapsed = 0;
        index = (index + 1 + Math.floor(Math.random() * (QUOTES.length - 1))) % QUOTES.length;
        current = QUOTES[index];
        return true;
      }
      return false;
    },
    forceNext() {
      index = (index + 1) % QUOTES.length;
      current = QUOTES[index];
      elapsed = 0;
    },
  };
}
